<script context="module" lang="ts">
	export type TotalAmountProps = {
		totalSalesCount: number;
		totalSalesAmount: number;
		totalDiscount: number;
	};

</script>
<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui/src";
	//Utils
	import { formatKrwNumber } from "@hitit/hub/src/v7/utils";
	//Types
	//Props
	export let totalSalesCount = 0;
	export let totalSalesAmount = 0;
	export let totalDiscount = 0;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<Card noPadding>
	<div class="container" t-id={'total-amount'}>
		<p class="title-qt">총 매출 ({totalSalesCount}건)</p>
		<p class="amount">{formatKrwNumber(totalSalesAmount)}원</p>
		<p class="discount">
			할인
			<span class="discount">- {formatKrwNumber(totalDiscount)}원</span>
		</p>
	</div>
</Card>

<style lang="scss">
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		padding: 20px 10px;
		gap: 10px;
		p.title-qt {
			color: #46474b;
		}
		p.amount {
			font-weight: 600;
			color: #3c68d6;
			font-size: 2.125rem;
		}
		p.discount {
			display: flex;
			gap: 10px;
			font-weight: 500;
			color: #6d6f76;
			font-size: 1.25rem;
			span.discount {
				color: #e54848;
			}
		}
	}

</style>
